import React from 'react';
import { LoadingPage } from '@bentley/pw-components';
import { useAuthentication } from '../../hooks/useAuthentication';
import { t } from '../../services/translation';
import { Redirect } from '../redirect';

type AuthenticateRouteProps = {
  route: string;
};

export function AuthenticateRoute({
  route
}: AuthenticateRouteProps): JSX.Element {
  const user = useAuthentication();

  if (!user) {
    return <LoadingPage loadingSubText={t('SignIn.SigningIn')} />;
  }

  const url = new URL(window.location.href);

  const redirectTo = `/${route}${url.search}`;

  return <Redirect to={redirectTo} />;
}
